import React from "react";
import ProjectCard from "../components/ProjectCard";

import youTubeImg from "../assets/projects/youtube.jpg";
import phonePeImg from "../assets/projects/phonepe.png";
import airBnbImg from "../assets/projects/airbnb.png";
import airWaterImg from "../assets/projects/air and water pollution.jpg";
import covidImg from "../assets/projects/covid analysis.jpg";
import iplImg from "../assets/projects/IPL_Analysis.webp";
import copperImg from "../assets/projects/Industrial Copper.jpg";
import flatImg from "../assets/projects/flat predictor.jpg";
import tutorImg from "../assets/projects/Tutor_Analysis.avif";

const ml = [
  {
    image: airWaterImg, tag: "Real-time ML", stack: "Python · Streamlit · ML",
    title: "Global Pollution Analysis & Prediction",
    description: "Live dashboard monitoring global air & water quality, predicting waterborne/airborne disease risk to alert at-risk regions.",
    github: "https://github.com/MDAnsaar25/Water-and-Air-Quality-Analysis-and-Prediction",
    liveDemo: "https://water-and-air-quality-analysis-and-prediction.streamlit.app/",
  },
  {
    image: copperImg, tag: "Classification", stack: "regression + clf",
    title: "Industrial Copper Modeling",
    description: "Predicts selling price and WON/LOST deal status of industrial copper orders from real manufacturing data.",
    github: "https://github.com/MDAnsaar25/industrial-copper-modeling",
  },
  {
    image: flatImg, tag: "Regression", stack: "Python · Streamlit · live",
    title: "Singapore Flat Resale Predictor",
    description: "Interactive Streamlit app predicting Singapore HDB resale prices with ML and a clean visual results layer.",
    github: "https://github.com/MDAnsaar25/Singapore-Flat-Resale-Predictor",
    liveDemo: "https://singapore-flat-resale-predictor-llut.onrender.com/",
  },
  {
    image: tutorImg, tag: "Prediction", stack: "Python · Streamlit",
    title: "Tutor Performance Analysis",
    description: "Analytical and Prediction project for the EdTech sector that evaluates tutor performance, computes a mental stress risk score, and predicts student churn using machine learning.",
    github: "https://github.com/MDAnsaar25/Tutor-Performance-Analysis-Dashboard",
  }

];

const data = [
  {
    image: youTubeImg, tag: "Data Engineering", stack: "Python · MongoDB · Streamlit",
    title: "YouTube Data Harvesting",
    description: "Automated collection and warehousing of YouTube data, with an interactive layer for key video insights.",
    github: "https://github.com/MDAnsaar25/Youtube-Data-harvesting-and-Ware-housing",
  },
  {
    image: phonePeImg, tag: "Analytics", stack: "Streamlit · Plotly · GeoJSON",
    title: "PhonePe Pulse Analysis",
    description: "Explores regional transaction trends in PhonePe Pulse with geo-mapped, interactive visualisations.",
    github: "https://github.com/MDAnsaar25/Phonepe-Project",
  },
  {
    image: airBnbImg, tag: "BI Dashboard", stack: "Power BI",
    title: "Airbnb Analysis",
    description: "BI dashboard analysing pricing, reviews, and host behaviour from Airbnb listing data.",
    github: "https://github.com/MDAnsaar25/Airbnb-Analysis",
  },
  {
    image: covidImg, tag: "Analysis", stack: "pandas · Plotly",
    title: "COVID-19 Global Insights",
    description: "Visualised pandemic trends and forecasted case growth with Matplotlib, Plotly, and pandas.",
    github: "https://github.com/MDAnsaar25/Covid-Analysis",
  },
  {
    image: iplImg, tag: "Analysis", stack: "pandas · viz",
    title: "IPL Match Insights",
    description: "Cleaned and visualised IPL data to surface win ratios, top scorers, and team strengths.",
    github: "https://github.com/MDAnsaar25/IPL-Match-Data-Analysis",
  },
];

const Projects = () => {
  return (
    <div className="sec" id="projects">
      <div className="wrap">
        <div className="sec-h"><span className="hash">##</span> evaluation results — projects</div>

        <h3 className="proj-group" data-aos="fade-up">machine learning &amp; data science</h3>
        <div className="proj-grid">
          {ml.map((p) => <ProjectCard key={p.title} {...p} />)}
        </div>

        <h3 className="proj-group" data-aos="fade-up" style={{ marginTop: 36 }}>data analysis &amp; visualization</h3>
        <div className="proj-grid">
          {data.map((p) => <ProjectCard key={p.title} {...p} />)}
        </div>

        <h3 className="proj-group" data-aos="fade-up" style={{ marginTop: 36 }}>llm &amp; language models</h3>
        <div className="proj-inprogress" data-aos="fade-up">
          <span className="ip-dot" />
          <div>
            <b>in active development</b>
            <p>Building retrieval-augmented (RAG) and agent-based projects with Hugging Face transformers and LLM APIs — shipping soon, with live demos like the rest.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;